import React from 'react';
import { LoadingContainer, LoadingGif } from './styles.ts';

const LoadingComponent = () => {
  const brand = process.env.REACT_APP_BRAND || 'Analytics';
  const gifIcon = require(`../../assets/${brand}/Icone_Gif.gif`);
  return (
    <LoadingContainer>
      <LoadingGif src={gifIcon} alt="Carregando..." />
    </LoadingContainer>
  );
};

export default LoadingComponent;
